import React from 'react';
import { goBack } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import T from 'i18n-react';


const Navigation = () => {
    const dispatch = useDispatch();

    const backClick = () => {
        dispatch(goBack());
    }

    return (
        <div>
            <a onClick={backClick} >{T.translate("BackNavigation.back")}</a>
        </div>
    )
};

export default Navigation;